import { designSystemColors } from '../colors';

export const backgroundToTextColor = {
  cedar: designSystemColors.white,
  cedarShade: designSystemColors.white,
  cedarTint: designSystemColors.white,
  charcoal: designSystemColors.white,
  ocean: designSystemColors.white,
  poppy: designSystemColors.charcoal,
  poppyLight: designSystemColors.charcoal,
  poppyMidTint: designSystemColors.charcoal,
  poppyShade: designSystemColors.white,
  poppy06: designSystemColors.white,
  poppyTint: designSystemColors.charcoal,
  lake: designSystemColors.charcoal,
  lakePop: designSystemColors.charcoal,
  lakeShade: designSystemColors.charcoal,
  lakeTint: designSystemColors.charcoal,
  lavender: designSystemColors.charcoal,
  lavenderLight: designSystemColors.charcoal,
  lavenderMidTint: designSystemColors.charcoal,
  lavenderShade: designSystemColors.charcoal,
  lavenderTint: designSystemColors.charcoal,
  lemon: designSystemColors.charcoal,
  lightSand: designSystemColors.charcoal,
  sage: designSystemColors.charcoal,
  sageLight: designSystemColors.charcoal,
  sageMidTint: designSystemColors.charcoal,
  sageShade: designSystemColors.charcoal,
  sageTint: designSystemColors.charcoal,
  sageTint2: designSystemColors.charcoal,
  sand: designSystemColors.charcoal,
  sandShade: designSystemColors.charcoal,
  sandTint: designSystemColors.charcoal,
  storm: designSystemColors.white,
  stormShade: designSystemColors.white,
  stormTint: designSystemColors.charcoal,
  transparent: designSystemColors.charcoal,
  warningBrown: designSystemColors.warningBrown,
  warningYellow: designSystemColors.warningYellow,
  white: designSystemColors.charcoal,
};
